export const applyOrientalLandscapeStyle = async (canvas, ctx, setMessage, language) => {
  // 산수화: 동양화의 산과 물 표현
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 수묵화 기본 처리 (직접 구현)
  // 그레이스케일 변환
  for (let i = 0; i < data.length; i += 4) {
    const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
    data[i] = gray;
    data[i + 1] = gray;
    data[i + 2] = gray;
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 먹의 농도 조절 (4단계)
  const inkLevels = [255, 180, 100, 30];
  const inkData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const inkPixels = inkData.data;
  
  for (let i = 0; i < inkPixels.length; i += 4) {
    const brightness = inkPixels[i];
    let inkLevel;
    
    if (brightness > 200) {
      inkLevel = inkLevels[0]; // 흰색 (종이)
    } else if (brightness > 130) {
      inkLevel = inkLevels[1]; // 연한 먹
    } else if (brightness > 70) {
      inkLevel = inkLevels[2]; // 진한 먹
    } else {
      inkLevel = inkLevels[3]; // 매우 진한 먹
    }
    
    inkPixels[i] = inkLevel;
    inkPixels[i + 1] = inkLevel;
    inkPixels[i + 2] = inkLevel;
  }
  
  ctx.putImageData(inkData, 0, 0);
  
  // 2. 산수화 특유의 공간감 추가
  const depthData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const depthPixels = depthData.data;
  
  // 거리에 따른 농담 조절 (원근법)
  for (let y = 0; y < canvas.height; y++) {
    const distanceFactor = y / canvas.height; // 위쪽이 먼 거리
    
    for (let x = 0; x < canvas.width; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      // 먼 거리일수록 흐릿하고 밝게
      const fadeAmount = distanceFactor * 50;
      
      for (let c = 0; c < 3; c++) {
        depthPixels[pos + c] = Math.min(255, depthPixels[pos + c] + fadeAmount);
      }
    }
  }
  
  ctx.putImageData(depthData, 0, 0);
  
  // 3. 산의 윤곽선 강조
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const mountainData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const mountainPixels = mountainData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 수직 방향의 그라디언트 검출 (산의 형태)
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      const current = tempData[pos];
      const above = tempData[((y - 1) * canvas.width + x) * 4];
      const below = tempData[((y + 1) * canvas.width + x) * 4];
      
      // 수직 변화가 큰 부분 (산의 능선)
      const verticalGradient = Math.abs(above - below);
      
      if (verticalGradient > 30) {
        // 능선 부분을 더 진하게
        mountainPixels[pos] = Math.max(0, mountainPixels[pos] - 40);
        mountainPixels[pos + 1] = Math.max(0, mountainPixels[pos + 1] - 40);
        mountainPixels[pos + 2] = Math.max(0, mountainPixels[pos + 2] - 40);
      }
    }
  }
  
  ctx.putImageData(mountainData, 0, 0);
  
  // 4. 안개 효과 (산수화의 운무)
  const mistData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const mistPixels = mistData.data;
  
  // 수평선 형태의 안개 띠 생성
  for (let y = 0; y < canvas.height; y++) {
    const mistStrength = Math.sin(y * 0.02) * 0.3 + 0.2;
    
    if (Math.random() < mistStrength) {
      for (let x = 0; x < canvas.width; x++) {
        const pos = (y * canvas.width + x) * 4;
        
        // 안개 효과로 밝게
        const mistEffect = 30 + Math.random() * 20;
        for (let c = 0; c < 3; c++) {
          mistPixels[pos + c] = Math.min(255, mistPixels[pos + c] + mistEffect);
        }
      }
    }
  }
  
  ctx.putImageData(mistData, 0, 0);
  
  // 5. 전통적인 점법(點法) 효과
  const dotData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const dotPixels = dotData.data;
  
  for (let i = 0; i < 200; i++) {
    const x = Math.floor(Math.random() * canvas.width);
    const y = Math.floor(Math.random() * canvas.height);
    const pos = (y * canvas.width + x) * 4;
    
    // 어두운 부분에만 점법 적용
    if (pos < dotPixels.length - 4 && dotPixels[pos] < 150) {
      const dotSize = Math.random() * 3 + 1;
      
      ctx.fillStyle = `rgba(0, 0, 0, ${0.3 + Math.random() * 0.4})`;
      ctx.beginPath();
      ctx.arc(x, y, dotSize, 0, 2 * Math.PI);
      ctx.fill();
    }
  }
};